'use strict';

var style = require('./style');

module.exports = style({
  prop: 'borderRadius',
  key: 'radii',
  numberToPx: true
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/border-radius.js
// module id = 107
// module chunks = 35783957827783 114276838955818 214865505688126